import config from '../../config/config';
import { UserParameters } from '../../interface/users-management.interface';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchUsersListFilters: (): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/users/list-filters`);
  },
  /**
   * Fetch the Single user
   * @param {any} id - The id
   */
  fetchUserActivityLogs: (id: String): Promise<any> =>
    getRequest(`${config.notificationApiUrl}api/super-admin/v1/general-log/activityLog/${id}`),
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  exportUsers: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/users/export-users`, {
      ...parameters,
    });
  },
  /**
   * Create the user api call function
   * @param {any} data - The user details
   * @returns {any} A promise that resolves with the creation response
   */
  createUser: (
    data: UserParameters = {
      name: '',
      email: '',
      role: '',
      roles: [],
      password: '',
      phoneNumber: '',
      countryCode: '',
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.subscription.accountApiUrl}api/common/v1/users`, {
      ...parameters,
    });
  },
  /**
   * Update the user api call function
   * @param {any} id - The user ID to update
   * @param {any} data - The updated user details
   * @returns {any} A promise that resolves with the update response
   */
  editUser: (
    id: string,
    data: UserParameters = {
      name: '',
      email: '',
      roles: [],
      phoneNumber: '',
      countryCode: '',
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.subscription.accountApiUrl}api/common/v1/users/${id}`, {
      ...parameters,
    });
  },
  /**
   * Delete the user api call function
   * @param {any} id - The user ID to delete
   * @returns {any} A promise that resolves with the response
   */
  deleteUser: (id: String): Promise<any> => {
    return deleteRequest(`${config.subscription.accountApiUrl}api/common/v1/users/${id}`);
  },
};
